<template>
  <a :href="urlHome" class="logotype" :class="{ 'logotype--large': large, 'logotype--white': white }">
    <img :src="src" alt="KERP" class="logotype__image">
    <div class="logotype__header" v-if="title || subTitle">
      <span class="logotype__title" v-if="title">{{ title }}</span>
      <small class="logotype__subtitle" v-if="subTitle">{{ subTitle }}</small>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    dataLarge: {
      type: Boolean,
      required: false
    },
    dataWhite: {
      type: Boolean,
      required: false
    },
    src: {
      type: String,
      required: false,
      default: '/images/logo.png'
    },
    title: {
      type: String,
      required: false,
      default: 'YARDAPP'
    },
    subTitle: {
      type: String,
      required: false,
      default: 'Administración de contenedores'
    },
    urlHome : {
      type : String,
      required : false,
      default : url + '/'
    }
  },
  data () {
    return {
      large: this.dataLarge,
      white: this.dataWhite
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/layout/Logo.vue